import { AuthContext } from "@/contexts/AuthContext";
import { SparklesIcon } from "@heroicons/react/24/outline";
import { useContext, useState } from "react";

// Minimum days in GOTA required to create a second shield (12 months ≈ 365 days)
const SHIELD_TWO_MIN_GOTA_DAYS = 365;

/**
 * A banner component that shows when the user is eligible to create a second shield.
 * They must have 12+ months in GOTA and not already have a ShieldTwo.
 */
export function ShieldTwoEligibilityBanner() {
    const { user, isAuthenticated } = useContext(AuthContext);
    const [dismissed, setDismissed] = useState(false);

    // Check eligibility conditions
    const player = user?.player;
    const gotaDays = player?.gotaSubTimeInDays ?? 0;
    const hasShieldTwo = !!player?.shieldTwo?.id;
    const isEligible = gotaDays >= SHIELD_TWO_MIN_GOTA_DAYS && !hasShieldTwo;

    // Only show if user is authenticated, eligible, and hasn't dismissed
    if (!isAuthenticated || !isEligible || dismissed) {
        return null;
    }

    const handleNavigate = () => {
        window.location.href = "/forge-shield-two";
    };

    const handleDismiss = () => {
        setDismissed(true);
    };

    return (
        <div
            className="fixed right-0 bottom-0 left-0 z-40 bg-zinc-800 p-4 shadow-lg"
            role="alert"
            aria-live="polite"
        >
            <div className="container mx-auto flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <SparklesIcon className="h-6 w-6 shrink-0 text-yellow-300" />
                    <div>
                        <p className="font-semibold text-white">
                            You're Eligible for a Second Shield!
                        </p>
                        <p className="text-sm text-purple-100">
                            Skál on reaching 12 months in the GILDI of the
                            ÁRMAÐR! You can now forge your second shield.
                        </p>
                    </div>
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={handleNavigate}
                        className="rounded bg-yellow-400 px-4 py-2 font-semibold text-purple-900 transition hover:bg-yellow-300"
                    >
                        Forge Second Shield
                    </button>
                    <button
                        onClick={handleDismiss}
                        className="rounded border border-white px-4 py-2 font-semibold text-white transition hover:bg-purple-600"
                    >
                        Dismiss
                    </button>
                </div>
            </div>
        </div>
    );
}
